import React from 'react';
const NotFound = () => {
    return (
        <>
            <h1 className='page-header'>Not Found!</h1>
        </>
    );
};

export default NotFound;